export default __webpack_public_path__ + "static/media/insta.fe895436.svg";